import { Icon } from "@/components/icons/Icon";
import type { IconName } from "@/components/icons/icons";
import { ADMIN_MENU, BASE_URL, TMA_MENU } from "@/constants/constants";
import { cn } from "@/lib/styles.utils";
import { APP_VERSION } from "@/lib/version";
import { useUserStore } from "@/store/useUser";
import { Link, useLocation } from "react-router-dom";

const Aside = () => {
  const { pathname } = useLocation();
  const { isSupervisor } = useUserStore();

  const MENU = isSupervisor ? ADMIN_MENU : TMA_MENU;

  return (
    <aside
      data-testid="aside-admin"
      className="hidden md:flex  shrink-0 h-full bg-[#FAFAFA] "
    >
      <div className="h-full w-full flex flex-col justify-between">
        <nav className="flex-1 overflow-y-auto p-4 space-y-2">
          {MENU.map((it) => (
            <Link
              key={it.label}
              to={it.href}
              className={cn(
                "flex flex-col justify-center rounded py-2 hover:bg-white/10 items-center",
                {
                  "text-ib-red-main font-ib-bold":
                    it.href !== BASE_URL && pathname.includes(it.href),
                },

                it.href === "requests" && pathname.includes("request")
                  ? "px-[9.5px]"
                  : "px-3",
              )}
            >
              <Icon name={it.icon as IconName} className="size-6 text-sm " />
              <p>{it.label}</p>
            </Link>
          ))}
        </nav>
        <div className="self-center py-4 text-xs text-gray-300">
          {APP_VERSION}
        </div>
      </div>
    </aside>
  );
};

export default Aside;
